export default __webpack_public_path__ + "static/media/MobileCategoryBackground.c99dd280.png";